module.exports = __webpack_public_path__ + "img/command01.1e2d007a.png";